import { getLang } from "@/lib/i18n";

export const SERVICE = { truck: "شاحنة", flatbed: "نصف شاحنة — سطحة", lorry: "نصف شاحنة — هاف لوري", light: "مركبة خفيفة", tanker: "صهريج", tow: "نصف شاحنة — سطحة" };
export const SERVICE_LONG = SERVICE;
export const MAIN_TYPES = [["truck", "شاحنة"], ["half", "نصف شاحنة"], ["light", "مركبة خفيفة"], ["tanker", "صهريج"]];
export const HALF_SUBS = ["flatbed", "lorry"];
export const NATIONALITIES = ["هندي", "باكستاني", "سوري", "مصري", "بنغلاديشي"];
export const PAY_STATUS = { unpaid: "غير مدفوع", partial: "مدفوع جزئياً", paid: "مدفوع بالكامل" };
export const PAY_METHOD = { cash: "نقداً", transfer: "تحويل", link: "رابط دفع", other: "أخرى" };
export const TRIP_STATUS = { created: "جديدة", in_transit: "قيد النقل", delivered: "تم التسليم" };
export const DRIVER_STATUS = { active: "نشط", suspended: "موقوف", inactive: "غير نشط" };
export const VEHICLE_STATUS = { active: "في الخدمة", maintenance: "في الصيانة", out: "خارج الخدمة" };
export const DOC_TYPES = {
  civil_id: "البطاقة المدنية", passport: "جواز السفر", license: "رخصة القيادة",
  ownership: "دفتر ملكية المركبة", registration: "استمارة المركبة", insurance: "تأمين المركبة", trade_license: "ترخيص النشاط التجاري", work_permit: "إذن العمل",
};
export const DOC_STATUS = { valid: "ساري", expiring: "قريب الانتهاء", expired: "منتهي", none: "بدون تاريخ انتهاء" };
export const NOTIF_TYPES = { violation: "مخالفة مرورية", admin_note: "ملاحظة إدارية", document_alert: "تنبيه مستند", general: "إشعار عام" };
export const PUSH_STATUS = { pending: "قيد الإرسال", sent: "أُرسل للجهاز", failed: "فشل الإرسال", no_subscription: "الجهاز غير مفعّل للتنبيهات" };

export function kwd(fils) {
  const f = Number(fils || 0);
  const sign = f < 0 ? "-" : "";
  const a = Math.abs(f);
  return `${sign}${Math.floor(a / 1000).toLocaleString("en-US")}.${String(a % 1000).padStart(3, "0")}`;
}

export function filsToInput(fils) {
  const a = Math.abs(Number(fils || 0));
  return `${Math.floor(a / 1000)}.${String(a % 1000).padStart(3, "0")}`;
}

const TZ = { timeZone: "Asia/Kuwait" };
const LOC = () => (getLang() === "ar" ? "ar-KW-u-nu-latn" : "en-GB");
export function fmtDate(s) {
  if (!s) return "—";
  return new Date(s.length === 10 ? s + "T12:00:00+03:00" : s).toLocaleDateString(LOC(), { ...TZ, year: "numeric", month: "2-digit", day: "2-digit" });
}
export function fmtDateTime(s) {
  if (!s) return "—";
  return new Date(s).toLocaleString(LOC(), { ...TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
}
export const todayISO = () => new Date().toLocaleDateString("en-CA", TZ);

export function locText(l) {
  if (!l) return "—";
  if (!l.available) return "الموقع غير متاح";
  return `${l.lat.toFixed(5)}, ${l.lng.toFixed(5)}${l.accuracy != null ? ` (±${Math.round(l.accuracy)}م)` : ""}`;
}
export const mapLink = (l) => (l?.available ? `https://maps.google.com/?q=${l.lat},${l.lng}` : null);

export function getLocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve({ available: false, reason: "الجهاز لا يدعم تحديد الموقع" });
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ available: true, lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
      (e) => resolve({ available: false, reason: e.code === 1 ? "لم يتم السماح بالوصول للموقع" : "تعذر تحديد الموقع" }),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 }
    );
  });
}

const KEY_AR = {
  invoices: "الفواتير", documents: "المستندات", violations: "المخالفات", fee_payments: "دفعات الرسوم", rows: "عدد الصفوف", sent: "المُرسل",
  dropoff: "التسليم", pickup: "الاستلام", price_fils: "السعر", total_fils: "المبلغ", paid_fils: "المحصل", amount: "المبلغ", price: "السعر",
  payment_status: "حالة الدفع", payment_method: "طريقة الدفع", status: "الحالة", requester_phone: "الهاتف", requester_name: "الاسم",
  customer_name: "العميل", car_plate: "لوحة السيارة", car_type: "نوع السيارة", load_desc: "الحمولة", goods_type: "الأغراض", number: "الرقم",
  full_name: "الاسم", phone: "الهاتف", work_types: "نوع العمل", driver_id: "السائق", plate: "اللوحة", type: "النوع", title: "العنوان",
  count: "العدد", rows: "عدد الصفوف", expiry_date: "الانتهاء", issue_date: "الإصدار", serial: "الرقم التسلسلي", reason: "السبب", text: "النص",
  start_at: "البداية", date: "التاريخ", method: "الطريقة", stage: "المرحلة", delivered_at: "وقت التسليم", confirmed: "مؤكد",
};
const VAL_AR = { ...PAY_STATUS, ...PAY_METHOD, ...TRIP_STATUS, ...DRIVER_STATUS, ...SERVICE };
export function fmtChanges(o) {
  if (!o || typeof o !== "object") return "";
  return Object.entries(o).filter(([k, v]) => !k.endsWith("_location") && !(v && typeof v === "object" && !Array.isArray(v))).map(([k, v]) => {
    let val = v;
    if (k.endsWith("_fils") || k === "amount") val = typeof v === "number" ? kwd(v) : v;
    else if (Array.isArray(v)) val = v.map((x) => VAL_AR[x] || x).join("، ");
    else if (typeof v === "boolean") val = v ? "نعم" : "لا";
    else if (typeof v === "string") val = VAL_AR[v] || (/^\d{4}-\d{2}-\d{2}T/.test(v) ? fmtDateTime(v) : v);
    return `${KEY_AR[k] || k}: ${val ?? "—"}`;
  }).join(" • ");
}

export const newRef = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);

export async function compressImage(file, max = 1600) {
  if (!file.type.startsWith("image/")) return file;
  try {
    const bmp = await createImageBitmap(file);
    const scale = Math.min(1, max / Math.max(bmp.width, bmp.height));
    const c = document.createElement("canvas");
    c.width = Math.round(bmp.width * scale);
    c.height = Math.round(bmp.height * scale);
    c.getContext("2d").drawImage(bmp, 0, 0, c.width, c.height);
    const blob = await new Promise((r) => c.toBlob(r, "image/jpeg", 0.82));
    return blob ? new File([blob], (file.name || "photo").replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" }) : file;
  } catch {
    return file;
  }
}
